export const XRPLevelopmentProcessData = {
  mainText: `Our XRPL Development Processs`,
  description: `We figure out what you need, design an architecture that won't explode under load, build and security-audit everything on testnet, then deploy to production with monitoring that actually works. Honest advice upfront, battle-tested practices throughout, and support that doesn't disappear after launch.`,
  services: [
    {
      step: '1',
      title: 'Discovery & Strategy',
      description:
        "We start by understanding what you're actually trying to solve, not just what technology sounds cool. Sometimes the XRPL is perfect. Sometimes it's not. We'll tell you either way.",
      stepColor: 'blue',
    },
    {
      step: '2',
      title: 'Architecture & Design',
      description:
        'We map out your system architecture, choose the right XRPL features, and design for scalability from day one. Because "we\'ll scale later" is developer-speak for "this will break spectacularly."',
      stepColor: 'blue',
    },
    {
      step: '3',
      title: 'Development & Testing',
      description:
        'We leverage the XRPL Testnet to develop and test applications without risking real money. Our developers build with official XRPL libraries and follow battle-tested best practices.',
      stepColor: 'blue',
    },
    {
      step: '4',
      title: 'Security Audits',
      description:
        "Blockchain development isn't like building a website; one mistake can cost millions. We conduct thorough security reviews and test edge cases you didn't know existed.",
      stepColor: 'blue',
    },
    {
      step: '5',
      title: 'Deployment & Support',
      description:
        'We deploy to mainnet with monitoring in place, documentation that people can actually understand, and ongoing support you can count on.',
      stepColor: 'blue',
    },
  ],
};
